import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ApiResponse, BaseComponent, Contract, Customer, StoreService} from 'compob2b-libs';
import {map, takeUntil, tap} from 'rxjs/operators';
import {NbCardModule, NbFormFieldModule, NbInputModule, NbListModule} from '@nebular/theme';
import {FormsModule} from '@angular/forms';
import {TuiIcon} from '@taiga-ui/core';
import {TuiBadge} from '@taiga-ui/kit';

@Component({
  selector: 'app-modal-company',
  templateUrl: './modal-company.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbCardModule, NbFormFieldModule, NbInputModule, NbListModule, FormsModule, TuiIcon, TuiBadge]
})
export class PopupCompanyComponent extends BaseComponent {
  keyword = '';
  filteredContracts: Contract[] = [];
  contracts: Contract[] = [];
  selected = 0;

  private readonly customer$ = this.storeService.getCustomerAsync();

  constructor(private readonly storeService: StoreService) {
    super();
    this.customer$.pipe(takeUntil(this.unsubscribe)).subscribe(customer => {
      this.filteredContracts = this.contracts = customer.contracts;
      this.selected = customer.contractId;
    });
  }

  onKey() {
    const k = this.keyword.trim().toLowerCase();
    this.filteredContracts = k
      ? this.contracts.filter(item =>
        (item.counterParty?.company || '').toLowerCase().includes(k) ||
        (item.header || '').toLowerCase().includes(k))
      : this.contracts;
  }

  select(contract: Contract) {
    this.compoApiService.patch<number, Customer>('/customer/set-default-contract', contract.id).pipe(
      takeUntil(this.unsubscribe),
      map((response: ApiResponse<Customer>) => response.data),
      tap(_ => this.storeService.nextCurrentContract(contract))
    ).subscribe((customer: Customer) => {
      this.storeService.nextCustomer(customer);
      window.location.reload();
    });
  }

}
